if (!customElements.get('youtube-video')) {
  class YouTubeVideo extends HTMLElement {
    constructor() {
      super();
      this.player = null;
    }

    connectedCallback() {
      this.videoId = this.dataset.videoId;
      this.autoplay = this.hasAttribute('data-autoplay');
      this.thumbnailWrapper = this.querySelector('div.youtube-thumbnail');
      this.iframeContainer = this.querySelector('.youtube-iframe-container');

      // Bind click on the whole custom element, not a child
      this.addEventListener('click', (e) => {
        if (!this.player || (this.player && this.thumbnailWrapper && this.thumbnailWrapper.style.opacity !== '0')) {
          e.stopPropagation();
          this.loadVideo();
        }
      });

      if (!this.thumbnailWrapper && this.iframeContainer && this.iframeContainer.querySelector('iframe')) {
        this.initPlayer();
      }

      if (this.autoplay) {
        this.loadVideo();
      }
    }

    loadVideo() {
      if (this.player) {
        this.player.playVideo();
        return;
      }

      if (this.iframeContainer.querySelector('iframe')) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${this.videoId}?enablejsapi=1&autoplay=1&origin=${window.location.origin}`;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      this.iframeContainer.appendChild(iframe);

      if (this.thumbnailWrapper) {
        this.thumbnailWrapper.style.opacity = '0';
        this.thumbnailWrapper.style.pointerEvents = 'none';
      }

      this.initPlayer(iframe);
    }

    initPlayer(iframe) {
      const el = iframe || this.iframeContainer.querySelector('iframe');
      if (!el) return;

      const tryInit = () => {
        if (window.YT && window.YT.Player) {
          this.player = new YT.Player(el, {
            events: {
              onStateChange: (event) => this.onStateChange(event),
            },
          });
        }
      };

      if (window.YT && window.YT.Player) {
        tryInit();
      } else {
        window.addEventListener('youtube:api:ready', tryInit, { once: true });
      }
    }

    onStateChange(event) {
      this.dispatchEvent(
        new CustomEvent('youtube:state:change', {
          bubbles: true,
          detail: {
            state: event.data,
            videoElement: this,
          },
        })
      );
    }
  }

  customElements.define('youtube-video', YouTubeVideo);
}
